import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=5ce24454&scoped=true&"
import script from "./sales.vue?vue&type=script&lang=js&"
export * from "./sales.vue?vue&type=script&lang=js&"
import style0 from "./sales.vue?vue&type=style&index=0&id=5ce24454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce24454",
  null
  
)

export default component.exports